// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/All-Products/biouvSpray.png";
import thumb1 from "../assets/images/New-Products/Bio-uv-Sprey.jpg";
import thumb2 from "../assets/images/All-Products/biouvSpray.png";
import thumb3 from "../assets/images/All-Products/biouvspray2.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2, thumb3].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>BioUV 50+ Spray</h2>
              <p className="sub-heading text-muted">SPRAY SUNSCREEN FROM HEAD TO TOE </p>
              <h5>Product Overview</h5>
              <p>
                It is a formulation that provides photoprotection with a refreshing mist.
                It is recommended to be used on the entire body including Hair, Face and Body, hence,
                it is a sunscreen that provides full coverage protection. It has a DNA auto repair complex that prevents the DNA damage.
                Non –Sticky formula that is recommended for oily and acne prone skin for protection from sun-induced skin damage.
                Provides pollution protection and immediate hydration. 50 SPF PA+++ Broad spectrum and HEV Light defence
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">BioUV 50+ Spray ?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>EU Approved encapsulated UV Filters making it sunscreen of the next generation.</li>
                    <li>Hydration Complex helps repair disrupted skin barrier & counteracts premature aging.</li>
                    <li>Balances the skin microbiome while providing photoprotection.</li>
                    <li>Novel molecule Physavie® reduces thermal aging by preventing activation of heat-activated proteins.</li>
                    <li>Easy re-application, long lasting, non-comedogenic, hypoallergenic and water resistant.</li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>Shake well before use.</li>
                      <li>Hold the nozzle close to your skin.</li>
                      <li>Spray it generously.</li>
                      <li>Rub it thoroughly.</li>
                      <li>Re-apply every 2–3 hours.</li>
                    </ol>
                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>
                        <strong>Ectoin:</strong> It is a hydro-complex that provides protection from pollution, prevents the release of stress mediators, provides membrane stabilization, and increases membrane fluidity.
                      </li>
                      <li>
                        <strong>Physavie:</strong> It reduces collagen degradation and increases collagen levels in the body. It also reduces MMPs (Matrix Metalloproteinases) and plays an anti-inflammatory role against interleukin-8.
                      </li>
                      <li>
                        <strong>SunCat MTA:</strong> A next-generation encapsulated chemical sunscreen dispersion engineered to prevent immediate release of capsule contents, helping halt degradation of UV filters and increasing SPF. It minimizes photodegradation, ensures slow and controlled release, provides prolonged and consistent SPF values, and is non-irritant and non-absorbable for longer, safer skin residence time.
                      </li>
                      <li>
                        <strong>Hyaluronic acid:</strong> High and low molecular weight forms provide multi-level hydration.
                      </li>
                      <li>
                        <strong>Probiotics:</strong> Creates a biofilm using Bifida Ferment Lysate, repairs the disturbed skin barrier, and prevents premature skin aging.
                      </li>
                    </ul>
                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
